<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                A2P Registration Step 2 of 6
            </h2>
        </template>

        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8 shadow sm:rounded-md bg-white">
                <jet-form-section @submitted="saveProgress">
                    <template #title>
                        Step 2
                    </template>

                    <template #form>
                        <div class="col-span-6" v-if="$page.props.a2p.is_business">
                            <label class="flex flex-col">
                                <div>
                                    Business Type <span class="required">*</span>
                                </div>
                                <multiselect
                                    :options="businessTypeOptions"
                                    v-model="selectedBusinessType"
                                    :searchable="false"
                                    :clearable="false"
                                    select-label=""
                                    deselect-label=""
                                    label="label"
                                    placeholder="Select"
                                />
                            </label>
                        </div>

                        <div class="col-span-6" v-if="$page.props.a2p.is_business">
                            <label class="flex flex-col">
                                <div>
                                    Company Type <span class="required">*</span>
                                </div>
                                <multiselect
                                    :options="companyTypeOptions"
                                    v-model="selectedCompanyType"
                                    :searchable="false"
                                    :clearable="false"
                                    select-label=""
                                    deselect-label=""
                                    label="label"
                                    placeholder="Select"
                                />
                            </label>

                            <div class="flex" v-if="form.company_type == 'public'">
                                <jet-input
                                    class="mt-1 mr-2 block w-half"
                                    v-model="form.ticker"
                                    placeholder="Ticker Symbol"
                                />

                                <jet-input
                                    class="mt-1 mr-2 block w-half"
                                    v-model="form.stock_exchange"
                                    placeholder="Stock Exchange"
                                />

                            </div>
                        </div>

                        <div class="col-span-6" v-if="$page.props.a2p.is_business">
                            <label class="flex flex-col">
                                <div>
                                    Industry <span class="required">*</span>
                                </div>
                                <multiselect
                                    :options="industryOptions"
                                    v-model="selectedIndustry"
                                    :searchable="false"
                                    :clearable="false"
                                    select-label=""
                                    deselect-label=""
                                    label="label"
                                    placeholder="Select"
                                />
                            </label>
                        </div>

                        <div class="col-span-6" v-if="$page.props.a2p.is_business">
                            <label class="flex flex-col">
                                <div>
                                    Website URL <span class="required">*</span>
                                </div>
                                <jet-input
                                    class="mt-1 block w-full"
                                    v-model="form.website_url"
                                    placeholder=""
                                    required
                                />
                            </label>
                        </div>

                        <div class="col-span-6" v-if="$page.props.a2p.is_business">
                            <label class="flex flex-col">
                                <div>
                                    Social Media URLs
                                </div>
                                <jet-input
                                    class="mt-1 block w-full"
                                    v-model="form.social_media_urls"
                                    placeholder=""
                                />
                            </label>
                        </div>

                        <div class="col-span-6">
                            <label class="flex flex-col">
                                <div>
                                    Physical Address (as it appears on your EIN paperwork)<span class="required">*</span>
                                </div>
                                <jet-input
                                    class="mt-1 block w-full"
                                    v-model="form.street"
                                    placeholder="Street"
                                    required
                                />
                            </label>

                            <div class="flex">
                                <jet-input
                                    class="mt-1 mr-2 block w-full"
                                    v-model="form.city"
                                    placeholder="City"
                                    required
                                />

                                <div class="w-80 mt-1">
                                    <state-selector v-if="form.country=='US'" v-model="form.state" />
                                    <province-selector v-if="form.country=='CA'" v-model="form.state" />
                                </div>

                                <jet-input
                                    class="mt-1 block w-40 ml-2"
                                    v-model="form.postal_code"
                                    :placeholder="form.country=='US' ? 'Zip Code' : 'Postal Code'"
                                    required
                                />

                            </div>
                        </div>
                    </template>
                    <template #actions>
                        <Link :href="route('a2p.step1')" class="mr-auto" >
                            <jet-button secondary type="button">
                                Back
                            </jet-button>
                        </Link>
                        
                        <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                            Saved.
                        </jet-action-message>

                        <jet-button
                            :class="{ 'opacity-25': form.processing }"
                            :disabled="!goodToContinue"
                        >
                            Next
                        </jet-button>
                    </template>
                </jet-form-section>
                
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import JetButton from "./../../Jetstream/Button";
import JetFormSection from "./../../Jetstream/FormSection";
import JetInput from "./../../Jetstream/Input";
import JetInputError from "./../../Jetstream/InputError";
import JetLabel from "./../../Jetstream/Label";
import JetActionMessage from "./../../Jetstream/ActionMessage";
import JetSecondaryButton from "./../../Jetstream/SecondaryButton";

import stateSelector from "../../components/Address/StateSelector";
import provinceSelector from "../../components/Address/ProvinceSelector";

export default {
    name: 'A2P-Step2',
    props: [],
    components: {
        AppLayout,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        //vSelect,
        stateSelector,
        provinceSelector
    },
    data() {
        return {
            selectedBusinessType: null,
            selectedCompanyType: null,
            selectedIndustry: null,
            form: this.$inertia.form(
                {
                    _method: "POST",
                    street: this.$page.props.a2p.street,
                    city: this.$page.props.a2p.city,
                    state: this.$page.props.a2p.state,
                    postal_code: this.$page.props.a2p.postal_code,
                    country: this.$page.props.a2p.country,
                    ticker: this.$page.props.a2p.ticker,
                    stock_exchange: this.$page.props.a2p.stock_exchange,
                    company_type: this.$page.props.a2p.company_type,
                    business_type: this.$page.props.a2p.business_type,
                    industry: this.$page.props.a2p.industry,
                    website_url: this.$page.props.a2p.website_url,
                    social_media_urls: this.$page.props.a2p.social_media_urls,
                    step: 2,
                },
                {
                }
            ),
        }
    },
    computed: {
        goodToContinue() {
            if (
                !this.form.street || 
                !this.form.city ||
                !this.form.state ||
                !this.form.postal_code
            ) return false;

            if( this.$page.props.a2p.is_business) {
                if (
                    !this.form.company_type ||
                    !this.form.business_type || 
                    !this.form.industry ||
                    !this.form.website_url
                ) return false;
            }

            return true;
        },
        businessTypeOptions() {
            return [
                {value: "Sole Proprietorship", label: "Sole Proprietorship"},
                {value: "Partnership", label: "Partnership"},
                {value: "Limited Liability Corporation", label: "Limited Liability Corporation"},
                {value: "Co-operative", label: "Co-operative"},
                {value: "Non-profit Corporation", label: "Non-profit Corporation"},
                {value: "Corporation", label: "Corporation"},
            ]
        },
        companyTypeOptions() {
            return [
                {value: "private", label: "Private"},
                {value: "public"   , label : "Public"},
                {value: "non-profit", label: "Non-profit"},
                {value: "government", label: "Government"},
            ]
        }, 
        industryOptions() {
            let options = [{
                label: "Professional Services",
                value: "PROFESSIONAL"
            }, {
                label: "Real Estate",
                value: "REAL_ESTATE"
            }, {
                label: "Healthcare and Life Sciences",
                value: "HEALTHCARE"
            }, {
                label: "HR, Staffing or Recruitment",
                value: "HUMAN_RESOURCES"
            }, {
                label: "Energy and Utilities",
                value: "ENERGY"
            }, {
                label: "Entertainment",
                value: "ENTERTAINMENT"
            }, {
                label: "Retail and Consumer Products",
                value: "RETAIL"
            }, {
                label: "Transportation or Logistics",
                value: "TRANSPORTATION"
            }, {
                label: "Agriculture",
                value: "AGRICULTURE"
            }, {
                label: "Insurance",
                value: "INSURANCE"
            }, {
                label: "Postal and Delivery",
                value: "POSTAL"
            }, {
                label: "Education",
                value: "EDUCATION"
            }, {
                label: "Hospitality and Travel",
                value: "HOSPITALITY"
            }, {
                label: "Financial Services",
                value: "FINANCIAL"
            }, {
                label: "Political",
                value: "POLITICAL"
            }, {
                label: "Gambling and Lottery",
                value: "GAMBLING"
            }, {
                label: "Legal",
                value: "LEGAL"
            }, {
                label: "Construction, Materials, and Trade Services",
                value: "CONSTRUCTION"
            }, {
                label: "Non-profit Organization",
                value: "NGO"
            }, {
                label: "Manufacturing",
                value: "MANUFACTURING"
            }, {
                label: "Government Services and Agencies",
                value: "GOVERNMENT"
            }, {
                label: "Information Technology Services",
                value: "TECHNOLOGY"
            }, {
                label: "Media and Communication",
                value: "COMMUNICATION"
            }]
            return _.sortBy(options, 'label');
        },
    },
    methods: {
        saveProgress() {
            this.form.post("/verified/save-progress", {
                preserveScroll: true,
                onSuccess: (response) => {
                    
                },
            });
        },
    },
    watch: {
        'form.company_type' : function(val) {
            if (val != 'public') {
                this.form.ticker = "";
                this.form.stock_exchange = "";
            }
        },
        selectedBusinessType(newVal) {
            this.form.business_type = newVal ? newVal.value : null;
        },
        selectedCompanyType(newVal) {
            this.form.company_type = newVal ? newVal.value : null;
        },
        selectedIndustry(newVal) {
            this.form.industry = newVal ? newVal.value : null;
        }
    },
    mounted() {
        // Initialize selected values from form values
        this.selectedBusinessType =  this.businessTypeOptions.find(opt => opt.value ===  this.$page.props.a2p.business_type) || null;
        this.selectedCompanyType = this.companyTypeOptions.find(opt => opt.value === this.form.company_type) || null;
        this.selectedIndustry = this.industryOptions.find(opt => opt.value === this.form.industry) || null;
    },
};
</script>

<style lang="scss" scoped>

.required {
    @apply text-red-500 font-bold text-xl pl-1;
}

</style>
